import React, { useState, useEffect } from 'react';
import emailjs from '@emailjs/browser';
import SEO from '../../components/common/SEO';

function Contact() {
  const [formData, setFormData] = useState({ from_name: '', phone: '', message: '' });
  const [sending, setSending] = useState(false);
  const [status, setStatus] = useState(null);

  const [screenWidth, setScreenWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 1200
  );
  useEffect(() => {
    function onResize() { setScreenWidth(window.innerWidth); }
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  const isMobile = screenWidth < 768;

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async () => {
    const phoneRegex = /^(0\d{10}|[1-9]\d{9})$/;

    if (!phoneRegex.test(formData.phone)) {
      setStatus('validation_error');
      return;
    }

    setSending(true);
    setStatus(null);
    try {
      await emailjs.send(
        'service_j7njzim',
        'template_2hnw1f3',
        formData,
        '0t3myGNVWRrrx-J7U'
      );
      setStatus('success');
      setFormData({ from_name: '', phone: '', message: '' });
    } catch (error) {
      console.error('EmailJS error:', error);
      setStatus('error');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="bg-white min-h-screen">
      <SEO title="Contact Us" description="Get in touch with Foundation Solar Energy Limited. Reach out for solar quotes, partnerships, or maintenance services." url="/contact" />

      {/* page header */}
      <section style={{
        background: 'linear-gradient(135deg, #0a1628 0%, #0d2240 50%, #0f2d5a 100%)',
        padding: '80px 24px 72px', textAlign: 'center',
        position: 'relative', overflow: 'hidden',
      }}>
        <div style={{
          position: 'absolute', inset: 0, opacity: 0.04,
          backgroundImage: 'linear-gradient(#fff 1px,transparent 1px),linear-gradient(90deg,#fff 1px,transparent 1px)',
          backgroundSize: '48px 48px',
        }} />
        <div style={{ position: 'relative', zIndex: 1 }}>
          <p style={{ fontSize: '11px', fontWeight: 600, letterSpacing: '0.2em', textTransform: 'uppercase', color: '#facc15', marginBottom: '16px' }}>
            Reach Out
          </p>
          <h1 style={{ fontSize: 'clamp(36px, 6vw, 64px)', fontWeight: 700, color: '#fff', lineHeight: 1.1, marginBottom: '20px' }}>
            Contact Us
          </h1>
          <div style={{ width: '60px', height: '3px', background: 'linear-gradient(to right, #3b82f6, #facc15)', borderRadius: '2px', margin: '0 auto 20px' }} />
          <p style={{ fontSize: '1.05rem', color: '#93c5fd', maxWidth: '480px', margin: '0 auto', lineHeight: 1.75 }}>
            We'd love to hear from you. Reach out and our team will get back to you promptly.
          </p>
        </div>
      </section>

      {/* questions form section */}
      <section style={{ background: '#f8faff', padding: isMobile ? '48px 16px 32px' : '80px 24px 48px' }}>
        <div style={{ maxWidth: '720px', margin: '0 auto' }}>
          <div style={{
            background: 'linear-gradient(135deg, #0a1628 0%, #0d2240 100%)',
            borderRadius: '24px', padding: isMobile ? '28px 20px' : '40px',
            boxShadow: '0 20px 60px rgba(13,34,64,0.15)',
            border: '1px solid rgba(255,255,255,0.06)',
          }}>
            <p style={{ fontSize: '11px', fontWeight: 600, letterSpacing: '0.18em', textTransform: 'uppercase', color: '#facc15', marginBottom: '6px' }}>
              Ask Away
            </p>
            <h2 style={{ fontSize: isMobile ? '20px' : '24px', fontWeight: 700, color: '#fff', marginBottom: '8px', lineHeight: 1.2 }}>
              Do You Have Any Questions For Us?
            </h2>
            <p style={{ fontSize: '14px', color: 'rgba(255,255,255,0.5)', marginBottom: '32px', lineHeight: 1.7 }}>
              Fill in your details and we'll get back to you as soon as possible.
            </p>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>

              <div>
                <label style={{ display: 'block', fontSize: '12px', fontWeight: 600, color: '#93c5fd', marginBottom: '6px', letterSpacing: '0.04em' }}>
                  Full Name
                </label>
                <input
                  type="text" name="from_name"
                  value={formData.from_name} onChange={handleChange}
                  placeholder="Your name"
                  style={{
                    width: '100%', padding: '12px 16px', borderRadius: '12px',
                    background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.12)',
                    color: '#fff', fontSize: '14px', outline: 'none',
                    transition: 'border-color 0.2s ease', boxSizing: 'border-box',
                  }}
                  onFocus={e => e.target.style.borderColor = '#facc15'}
                  onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.12)'}
                />
              </div>

              <div>
                <label style={{ display: 'block', fontSize: '12px', fontWeight: 600, color: '#93c5fd', marginBottom: '6px', letterSpacing: '0.04em' }}>
                  Phone Number
                </label>
                <input
                  type="tel" name="phone"
                  value={formData.phone} onChange={handleChange}
                  placeholder="+92 300 0000000"
                  style={{
                    width: '100%', padding: '12px 16px', borderRadius: '12px',
                    background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.12)',
                    color: '#fff', fontSize: '14px', outline: 'none',
                    transition: 'border-color 0.2s ease', boxSizing: 'border-box',
                  }}
                  onFocus={e => e.target.style.borderColor = '#facc15'}
                  onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.12)'}
                />
              </div>

              <div>
                <label style={{ display: 'block', fontSize: '12px', fontWeight: 600, color: '#93c5fd', marginBottom: '6px', letterSpacing: '0.04em' }}>
                  Your Question
                </label>
                <textarea
                  name="message" rows={5}
                  value={formData.message} onChange={handleChange}
                  placeholder="Type your question here..."
                  style={{
                    width: '100%', padding: '12px 16px', borderRadius: '12px',
                    background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.12)',
                    color: '#fff', fontSize: '14px', outline: 'none', resize: 'none',
                    transition: 'border-color 0.2s ease', boxSizing: 'border-box',
                    fontFamily: 'inherit',
                  }}
                  onFocus={e => e.target.style.borderColor = '#facc15'}
                  onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.12)'}
                />
              </div>

              {status && (
                <p style={{
                  fontSize: '13px', fontWeight: 600, textAlign: 'center',
                  color: status === 'success' ? '#4ade80' : '#f87171',
                }}>
                  {status === 'success'
                    ? '✓ Your question has been sent! We will get back to you soon.'
                    : status === 'validation_error'
                    ? '✗ pls enter correct format'
                    : '✗ Something went wrong. Please try again.'}
                </p>
              )}

              <button
                type="button" onClick={handleSubmit} disabled={sending}
                style={{
                  width: '100%', padding: '14px',
                  background: sending ? 'rgba(250,204,21,0.5)' : '#facc15',
                  color: '#0a1628', fontSize: '15px', fontWeight: 700,
                  borderRadius: '12px', border: 'none', cursor: sending ? 'not-allowed' : 'pointer',
                  transition: 'all 0.2s ease',
                }}
                onMouseEnter={e => { if (!sending) e.currentTarget.style.background = '#fde047'; }}
                onMouseLeave={e => { if (!sending) e.currentTarget.style.background = '#facc15'; }}
              >
                {sending ? 'Sending...' : 'Send Question'}
              </button>

            </div>
          </div>
        </div>
      </section>

      {/* two office cards */}
      <section style={{ background: '#f8faff', padding: isMobile ? '32px 16px 56px' : '48px 24px 80px' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>

          <div style={{ textAlign: 'center', marginBottom: '48px' }}>
            <p style={{ fontSize: '11px', fontWeight: 600, letterSpacing: '0.2em', textTransform: 'uppercase', color: '#1e3a8a', marginBottom: '10px' }}>
              Find Us
            </p>
            <h2 style={{ fontSize: 'clamp(22px, 3vw, 32px)', fontWeight: 700, color: '#0a1628', marginBottom: '8px' }}>
              Our Offices
            </h2>
            <div style={{ width: '48px', height: '3px', background: 'linear-gradient(to right, #1d4ed8, #facc15)', borderRadius: '2px', margin: '0 auto' }} />
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
            gap: isMobile ? '40px' : '48px',
            alignItems: 'start',
          }}>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
              <div style={{
                background: '#fff', borderRadius: '24px',
                padding: isMobile ? '24px 20px' : '40px',
                border: '1px solid #e8f0fe',
                boxShadow: '0 8px 32px rgba(13,34,64,0.07)',
              }}>
                <p style={{ fontSize: '11px', fontWeight: 600, letterSpacing: '0.18em', textTransform: 'uppercase', color: '#1e3a8a', marginBottom: '6px' }}>
                  Get in Touch
                </p>
                <h2 style={{ fontSize: isMobile ? '22px' : '26px', fontWeight: 700, color: '#0a1628', marginBottom: '24px', lineHeight: 1.2 }}>
                  Corporate Office
                </h2>
                <div style={{ width: '40px', height: '3px', background: 'linear-gradient(to right, #1d4ed8, #facc15)', borderRadius: '2px', marginBottom: '28px' }} />

                <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>

                  <div style={{ display: 'flex', gap: '14px', alignItems: 'flex-start' }}>
                    <div style={{ width: '40px', height: '40px', borderRadius: '10px', flexShrink: 0, background: '#eef4ff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <svg width="18" height="18" fill="none" stroke="#1e3a8a" strokeWidth="2" viewBox="0 0 24 24">
                        <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0118 0z"/>
                        <circle cx="12" cy="10" r="3"/>
                      </svg>
                    </div>
                    <div>
                      <p style={{ fontSize: '12px', fontWeight: 600, color: '#1e3a8a', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '4px' }}>Address</p>
                      <p style={{ fontSize: '14px', color: '#475569', lineHeight: 1.7 }}>
                        1st Floor, Al Ghani Arcade,<br />GT Road, Rawalpindi
                      </p>
                    </div>
                  </div>

                  <div style={{ display: 'flex', gap: '14px', alignItems: 'flex-start' }}>
                    <div style={{ width: '40px', height: '40px', borderRadius: '10px', flexShrink: 0, background: '#eef4ff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <svg width="18" height="18" fill="none" stroke="#1e3a8a" strokeWidth="2" viewBox="0 0 24 24">
                        <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.67A2 2 0 012 .18h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 14z"/>
                      </svg>
                    </div>
                    <div>
                      <p style={{ fontSize: '12px', fontWeight: 600, color: '#1e3a8a', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '4px' }}>Phone & Fax</p>
                      <a href="tel:051111113735" style={{ fontSize: '14px', color: '#475569', display: 'block', textDecoration: 'none', fontWeight: 'bold' }}
                        onMouseEnter={e => e.currentTarget.style.color = '#1d4ed8'}
                        onMouseLeave={e => e.currentTarget.style.color = '#475569'}>
                        UAN: 051 111-113-735
                      </a>
                      <a href="tel:05147209068" style={{ fontSize: '14px', color: '#475569', display: 'block', textDecoration: 'none', marginTop: '2px' }}
                        onMouseEnter={e => e.currentTarget.style.color = '#1d4ed8'}
                        onMouseLeave={e => e.currentTarget.style.color = '#475569'}>
                        Tel: 051 4720906 8
                      </a>
                      <a href="tel:03000503762" style={{ fontSize: '14px', color: '#475569', display: 'block', textDecoration: 'none', marginTop: '2px' }}
                        onMouseEnter={e => e.currentTarget.style.color = '#1d4ed8'}
                        onMouseLeave={e => e.currentTarget.style.color = '#475569'}>
                        Tel: 0300 0503762
                      </a>
                      <p style={{ fontSize: '13px', color: '#94a3b8', marginTop: '2px' }}>Fax: 051 4720908</p>
                    </div>
                  </div>

                  <div style={{ display: 'flex', gap: '14px', alignItems: 'flex-start' }}>
                    <div style={{ width: '40px', height: '40px', borderRadius: '10px', flexShrink: 0, background: '#eef4ff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <svg width="18" height="18" fill="none" stroke="#1e3a8a" strokeWidth="2" viewBox="0 0 24 24">
                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                        <polyline points="22,6 12,13 2,6"/>
                      </svg>
                    </div>
                    <div>
                      <p style={{ fontSize: '12px', fontWeight: 600, color: '#1e3a8a', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '4px' }}>Email</p>
                      <a href="mailto:contact@fsel.fonpv.org" style={{ fontSize: '14px', color: '#475569', textDecoration: 'none' }}
                        onMouseEnter={e => e.currentTarget.style.color = '#1d4ed8'}
                        onMouseLeave={e => e.currentTarget.style.color = '#475569'}>
                        contact@fsel.fonpv.org
                      </a>
                    </div>
                  </div>

                  <div style={{ display: 'flex', gap: '14px', alignItems: 'flex-start' }}>
                    <div style={{ width: '40px', height: '40px', borderRadius: '10px', flexShrink: 0, background: '#eef4ff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <svg width="18" height="18" fill="none" stroke="#1e3a8a" strokeWidth="2" viewBox="0 0 24 24">
                        <circle cx="12" cy="12" r="10"/>
                        <polyline points="12 6 12 12 16 14"/>
                      </svg>
                    </div>
                    <div>
                      <p style={{ fontSize: '12px', fontWeight: 600, color: '#1e3a8a', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '4px' }}>Office Hours</p>
                      <p style={{ fontSize: '14px', color: '#475569', lineHeight: 1.7 }}>
                        Monday – Friday: 9:00 AM – 5:00 PM<br />
                        <span style={{ color: '#94a3b8', fontSize: '13px' }}>Saturday – Sunday: Closed</span>
                      </p>
                    </div>
                  </div>

                </div>
              </div>

              <div style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 48px rgba(13,34,64,0.1)', border: '1px solid #e8f0fe' }}>
                <iframe
                  title="FSEL Corporate Office Location"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1662.820202552518!2d73.1264064!3d33.5367338!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38dfed732cf180f3%3A0x4c26ff3d71f45d52!2sAl%20Ghani%20Arcade!5e0!3m2!1sen!2s!4v1773692747485!5m2!1sen!2s"
                  width="100%"
                  height={isMobile ? '240' : '320'}
                  style={{ border: 0, display: 'block' }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'center' }}>
                <svg width="16" height="16" fill="none" stroke="#1e3a8a" strokeWidth="2" viewBox="0 0 24 24">
                  <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0118 0z"/>
                  <circle cx="12" cy="10" r="3"/>
                </svg>
                <p style={{ fontSize: '13px', color: '#64748b' }}>
                  1st Floor, Al Ghani Arcade, GT Road, Rawalpindi
                </p>
              </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
              <div style={{
                background: '#fff', borderRadius: '24px',
                padding: isMobile ? '24px 20px' : '40px',
                border: '1px solid #e8f0fe',
                boxShadow: '0 8px 32px rgba(13,34,64,0.07)',
              }}>
                <p style={{ fontSize: '11px', fontWeight: 600, letterSpacing: '0.18em', textTransform: 'uppercase', color: '#1e3a8a', marginBottom: '6px' }}>
                  Main Location
                </p>
                <h2 style={{ fontSize: isMobile ? '22px' : '26px', fontWeight: 700, color: '#0a1628', marginBottom: '24px', lineHeight: 1.2 }}>
                  Head Office
                </h2>
                <div style={{ width: '40px', height: '3px', background: 'linear-gradient(to right, #1d4ed8, #facc15)', borderRadius: '2px', marginBottom: '28px' }} />

                <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>

                  <div style={{ display: 'flex', gap: '14px', alignItems: 'flex-start' }}>
                    <div style={{ width: '40px', height: '40px', borderRadius: '10px', flexShrink: 0, background: '#eef4ff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <svg width="18" height="18" fill="none" stroke="#1e3a8a" strokeWidth="2" viewBox="0 0 24 24">
                        <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0118 0z"/>
                        <circle cx="12" cy="10" r="3"/>
                      </svg>
                    </div>
                    <div>
                      <p style={{ fontSize: '12px', fontWeight: 600, color: '#1e3a8a', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '4px' }}>Address</p>
                      <p style={{ fontSize: '14px', color: '#475569', lineHeight: 1.7 }}>
                        Fauji Towers, Tipu Rd,<br />Chaklala Cantt., Rawalpindi, 44000
                      </p>
                    </div>
                  </div>

                  <div style={{ display: 'flex', gap: '14px', alignItems: 'flex-start' }}>
                    <div style={{ width: '40px', height: '40px', borderRadius: '10px', flexShrink: 0, background: '#eef4ff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <svg width="18" height="18" fill="none" stroke="#1e3a8a" strokeWidth="2" viewBox="0 0 24 24">
                        <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.67A2 2 0 012 .18h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 14z"/>
                      </svg>
                    </div>
                    <div>
                      <p style={{ fontSize: '12px', fontWeight: 600, color: '#1e3a8a', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '4px' }}>Phone</p>
                      <a href="tel:0515951821" style={{ fontSize: '14px', color: '#475569', display: 'block', textDecoration: 'none' }}
                        onMouseEnter={e => e.currentTarget.style.color = '#1d4ed8'}
                        onMouseLeave={e => e.currentTarget.style.color = '#475569'}>
                        (051) 5951821
                      </a>
                    </div>
                  </div>

                  <div style={{ display: 'flex', gap: '14px', alignItems: 'flex-start' }}>
                    <div style={{ width: '40px', height: '40px', borderRadius: '10px', flexShrink: 0, background: '#eef4ff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <svg width="18" height="18" fill="none" stroke="#1e3a8a" strokeWidth="2" viewBox="0 0 24 24">
                        <circle cx="12" cy="12" r="10"/>
                        <polyline points="12 6 12 12 16 14"/>
                      </svg>
                    </div>
                    <div>
                      <p style={{ fontSize: '12px', fontWeight: 600, color: '#1e3a8a', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '4px' }}>Office Hours</p>
                      <p style={{ fontSize: '14px', color: '#475569', lineHeight: 1.7 }}>
                        Monday – Friday: 8:00 AM – 4:00 PM<br />
                        <span style={{ color: '#94a3b8', fontSize: '13px' }}>Saturday – Sunday: Closed</span>
                      </p>
                    </div>
                  </div>

                </div>
              </div>

              <div style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 48px rgba(13,34,64,0.1)', border: '1px solid #e8f0fe' }}>
                <iframe
                  title="FSEL Head Office Location"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1796.1167874305986!2d73.08256354643282!3d33.60620580139076!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38df94ad9a3fffff%3A0xbb109ca0410b8c47!2sFoundation%20Solar%20Energy%20(Pvt)%20Ltd%2C!5e0!3m2!1sen!2s!4v1774382069910!5m2!1sen!2s"
                  width="100%"
                  height={isMobile ? '240' : '320'}
                  style={{ border: 0, display: 'block' }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'center' }}>
                <svg width="16" height="16" fill="none" stroke="#1e3a8a" strokeWidth="2" viewBox="0 0 24 24">
                  <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0118 0z"/>
                  <circle cx="12" cy="10" r="3"/>
                </svg>
                <p style={{ fontSize: '13px', color: '#64748b' }}>
                  Fauji Towers, Tipu Rd, Chaklala Cantt., Rawalpindi, 44000
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>

    </div>
  );
}

export default Contact;